import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/gameTabs.css';

import {ASSETS_URL} from '../../../../constants/endpoints';
import {VIRTUALS} from '../../../../constants/games';

import GameTab from '../components/gameTab.js';

const mapStateToProps = (state, ownProps) => {
    return {games: state.vpp.games};
};

class GameTabs extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            games: storeData.vpp.games
        };
    }

    componentDidMount() {
        this._setScrollArrows();
        document.getElementById('gameTabsContainer').addEventListener('scroll', this._setScrollArrows.bind(this));
        window.addEventListener('resize', this._setScrollArrows.bind(this));
    }

    componentWillUnmount() {
        document.getElementById('gameTabsContainer').removeEventListener('scroll', this._setScrollArrows.bind(this));
        window.removeEventListener('resize', this._setScrollArrows.bind(this));
    }

    _setScrollArrows() {
        let tabs = document.getElementById('gameTabsContainer');
        let hasScrollLeft = false;
        let hasScrollRight = false;

        if (tabs) {
            if (tabs.scrollLeft > 0) {
                hasScrollLeft = true;
            }
            if (tabs.scrollWidth - tabs.scrollLeft > tabs.clientWidth) {
                hasScrollRight = true;
            }

            this.setState({
                ...this.state,
                hasScrollLeft,
                hasScrollRight
            });
        }
    }

    _scrollTabsLeft() {
        let tabs = document.getElementById('gameTabsContainer');
        if (tabs) {
            tabs.scrollLeft -= 50;
        }
    }

    _scrollTabsRight() {
        let tabs = document.getElementById('gameTabsContainer');
        if (tabs) {
            tabs.scrollLeft += 50;
        }
    }

    componentWillReceiveProps(nextProps) {
        let store = this.props.store;
        let storeData = store.getState();

        this.setState({games: storeData.vpp.games});
    }

    render() {
        let gameTabsUI = VIRTUALS.map(
            (game, index) => <GameTab game={game} gameindex={index} key={index} store={this.props.store}/>
        );

        let scrollLeft = this.state.hasScrollLeft
            ? <div className={style.leftArrow} id={'gameScrollLeft'} onClick={() => this._scrollTabsLeft()}><img
                className={style.leftArrowIcon} src={`${ASSETS_URL}back.svg`} alt='previous'/></div>
            : '';
        let scrollRight = this.state.hasScrollRight
            ? <div className={style.rightArrow} id={'gameScrollRight'} onClick={() => this._scrollTabsRight()}><img
                className={style.rightArrowIcon} src={`${ASSETS_URL}next.svg`} alt='next'/></div>
            : '';

        return (
            <div className={`${style.gameTabsContainer}`}>
                <div className={`${style.gameTabs} ${style.scroll}`} id='gameTabsContainer'>
                    {gameTabsUI}
                </div>
                {scrollLeft}
                {scrollRight}
            </div>
        );
    }
}

export default connect(mapStateToProps)(GameTabs);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/sharedComponents/containers/gameTabs.js